<script setup lang="ts">
import { useHead } from '#imports'
import { onMounted } from 'vue'

const props = defineProps({
    cdnUrl: {
        type: String,
        default: ''
    },
    locale: {
        type: String,
        default: 'en'
    }
})

useHead({
    script: [
        {
            src: `${props.cdnUrl}/js/didomiSdk.js`,
            defer: true
        }
    ]
})
onMounted(() => {
    ;(window as any).didomiConfig = {
        languages: {
            enabled: [props.locale],
            default: props.locale
        }
    }
})
</script>

<template>
    <div id="consent-notice-overlay" />
</template>

<style>
#consent-notice-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
  display: none;
}

#didomi-host > .notranslate > #didomi-popup > .didomi-exterior-border.didomi-popup__exterior-border {
  border: none !important;
  border-radius: 16px !important;
}
#didomi-host > .notranslate > #didomi-popup > .didomi-exterior-border.didomi-popup__exterior-border .didomi-popup-container.didomi-popup__dialog.didomi-popup-notice.didomi-popup-notice-optin-type {
  border-radius: 16px !important;
}
#didomi-host > .notranslate > #didomi-popup > .didomi-exterior-border.didomi-popup__exterior-border .didomi-popup-container.didomi-popup__dialog.didomi-popup-notice.didomi-popup-notice-optin-type .didomi-popup-view {
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
}
#didomi-host > .notranslate > #didomi-popup > .didomi-exterior-border.didomi-popup__exterior-border .didomi-popup-container.didomi-popup__dialog.didomi-popup-notice.didomi-popup-notice-optin-type .didomi-popup-view .didomi-popup-notice-logo-container {
  order: 1 !important;
}
#didomi-host > .notranslate > #didomi-popup > .didomi-exterior-border.didomi-popup__exterior-border .didomi-popup-container.didomi-popup__dialog.didomi-popup-notice.didomi-popup-notice-optin-type .didomi-popup-view .didomi-popup-notice-text-container {
  order: 2 !important;
}
#didomi-host > .notranslate > #didomi-popup > .didomi-exterior-border.didomi-popup__exterior-border .didomi-popup-container.didomi-popup__dialog.didomi-popup-notice.didomi-popup-notice-optin-type .didomi-popup-view .didomi-continue-without-agreeing {
  order: 3 !important;
  align-self: start !important;
  font-size: 11px !important;
  margin: 0 !important;
}
#didomi-host > .notranslate > #didomi-popup > .didomi-exterior-border.didomi-popup__exterior-border .didomi-popup-container.didomi-popup__dialog.didomi-popup-notice.didomi-popup-notice-optin-type .didomi-popup-view #buttons {
  order: 4 !important;
}
@media (min-width: 768px) {
  #didomi-host > .notranslate > #didomi-popup > .didomi-exterior-border.didomi-popup__exterior-border .didomi-popup-container.didomi-popup__dialog.didomi-popup-notice.didomi-popup-notice-optin-type .didomi-popup-view #buttons {
    flex-direction: row !important;
    gap: 10px !important;
  }
}
#didomi-host > .notranslate > #didomi-popup > .didomi-exterior-border.didomi-popup__exterior-border .didomi-popup-container.didomi-popup__dialog.didomi-popup-notice.didomi-popup-notice-optin-type .didomi-popup-view #buttons #didomi-notice-agree-button {
  background-color: #0da2e7 !important;
  border: 1px solid #0da2e7;
  border-radius: 8px !important;
  color: #ffffff !important;
}
#didomi-host > .notranslate > #didomi-popup > .didomi-exterior-border.didomi-popup__exterior-border .didomi-popup-container.didomi-popup__dialog.didomi-popup-notice.didomi-popup-notice-optin-type .didomi-popup-view #buttons #didomi-notice-agree-button:hover {
  color: #ffffff !important;
  background-color: #22bcff !important;
  border: 1px solid #22bcff;
}
#didomi-host > .notranslate > #didomi-popup > .didomi-exterior-border.didomi-popup__exterior-border .didomi-popup-container.didomi-popup__dialog.didomi-popup-notice.didomi-popup-notice-optin-type .didomi-popup-view #buttons #didomi-notice-learn-more-button {
  background-color: #ffffff !important;
  border: 1px solid #3f3f46;
  border-radius: 8px !important;
  color: #3f3f46 !important;
}
#didomi-host > .notranslate > #didomi-popup > .didomi-exterior-border.didomi-popup__exterior-border .didomi-popup-container.didomi-popup__dialog.didomi-popup-notice.didomi-popup-notice-optin-type .didomi-popup-view #buttons #didomi-notice-learn-more-button:hover {
  color: #71717a !important;
  background-color: #ffffff !important;
  border: 1px solid #71717a;
}
</style>
